module.exports = __webpack_public_path__ + "img/logo-white.6ac5f200.png";